import React, { useEffect, useState } from "react";
import "../../../Util.css";
import { MoveLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { Plus } from "lucide-react";
import chevron_down from "../../../assets/Vehicles/chevron_down.png";
import remove from "../../../assets/Expense/remove.png";
import add from "../../../assets/Expense/add.png";
import { Modal } from "react-bootstrap";
import CommonDropdown from "../../common/common_dropDown";
import { getVehicleDetailAPI } from "../Km_history/km_history_api";
import DOMPurify from "dompurify";
import ErrorExtractor from "../../common/error_extractor";
import { getExpenseDetAPI, submitAPI, UpdateAPI } from "./expense_api";
import { Toast, ToastContainer } from "react-bootstrap";
import { MoreVertical } from "lucide-react"; // Three-dot icon
import DeleteModal from "../../common/delete-modal";
export const NewExpense = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [openDropdown, setOpenDropdown] = useState(null); // store active tab key for dropdown

  const toggleDropdown = (key) => {
    setOpenDropdown(openDropdown === key ? null : key);
  };
  const location = useLocation();
  const { id } = location.state || {};
  const [selectedLicensePlate, setSelectedLicensePlate] = useState(null);
  const [vehicleName, setVehicleName] = useState(null);
  const [vinValue, setVinValue] = useState("");
  const [lastKmRecord, setLastKmRecord] = useState("0");
  const [currentKm, setCurrentKm] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const handleSelectLicensePlate = (item) => {
    console.log("Selected:", item);
    setSelectedLicensePlate(item); // store selected id
  };
  // close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".tab-dropdown")) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  useEffect(() => {
    getVehicleDetails();
  }, [selectedLicensePlate]);
  useEffect(() => {
    console.log("info.row.id12");
    console.log(id);
    console.log("ss->", id);
    if (id != null && id !== 0) {
      getExpenseDetails();
    }
  }, [id]);
  const getVehicleDetails = async () => {
    try {
      if (!selectedLicensePlate?.value) return; // safety check

      const response = await getVehicleDetailAPI(selectedLicensePlate.value);

      console.log("vehicle details", response);
      if (response.data?.success) {
        const vehicleData = response.data.vehicle;
        setVehicleName(vehicleData.name);
        setVinValue(vehicleData.vin);

        setLastKmRecord(vehicleData.kilometer_driven);
      } else {
        console.error("Failed to fetch vehicle details:", response.data?.message);
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };

  const handleCurrentKmChange = (e) => {
    let value = e.target.value;

    // Convert to number
    const current = parseFloat(value) || 0;
    const last = parseFloat(lastKmRecord) || 0;

    // Always set the typed value
    setCurrentKm(value);

    if (current < last) {
      setErrorMsg((prev) => ({
        ...prev,
        km: `Current KM cannot be less than last recorded KM (${last})`,
      }));
    } else {
      setErrorMsg((prev) => ({
        ...prev,
        km: "",
      }));
    }
  };

  const [errorMsg, setErrorMsg] = useState({
    vehicle_id: "",
    km: "",
    last_km: "",
    assigned_to: "",
    image: "",
  });
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("service");
  const [rowsByTab, setRowsByTab] = useState({});

  const handleAdd = (tabKey) => {
    setRowsByTab((prev) => ({
      ...prev,
      [tabKey]: [...prev[tabKey], { status: "", amount: "" }],
    }));
  };

  const handleRemove = (tabKey, index) => {
    setRowsByTab((prev) => {
      const updatedRows = { ...prev };
      const fields = updatedRows[tabKey] || [];

      const removedField = fields[index]; // The field being removed
      console.log("removedField", removedField);

      if (removedField && removedField.id != null) {
        setDeletedFieldIds((prevIds) => {
          if (!prevIds.includes(removedField.id)) {
            const updatedIds = [...prevIds, removedField.id];
            console.log("removedField inside updater", updatedIds);
            return updatedIds;
          }
          return prevIds;
        });
      }

      // Remove the field at the specified index
      updatedRows[tabKey] = fields.filter((_, i) => i !== index);

      return updatedRows;
    });
  };

  const handleExpenseNameChange = (tabKey, index, value) => {
    setRowsByTab((prev) => {
      const updatedRows = [...prev[tabKey]];
      updatedRows[index].status = value;
      return { ...prev, [tabKey]: updatedRows };
    });
  };
  const handleAmountChange = (tabKey, index, value) => {
    setRowsByTab((prev) => {
      const updatedRows = [...prev[tabKey]];
      updatedRows[index].amount = value;
      return { ...prev, [tabKey]: updatedRows };
    });
  };

  const [tabButtons, setTabButtons] = useState([]);
  const [expensesTitle, setExpneseTitle] = useState(null);
  const [expensesDelTitle, setExpneseDelTitle] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [newExpenseName, setNewExpenseName] = useState("");

  useEffect(() => {
    if (expensesTitle !== null) {
      console.log("expensesTitle", expensesTitle);
      setNewExpenseName(expensesTitle.name);
      setShowModal(true);
    }
  }, [expensesTitle]);
  const [deletedTabIds, setDeletedTabIds] = useState([]);
  const [deletedFieldIds, setDeletedFieldIds] = useState([]);
  useEffect(() => {
    if (expensesDelTitle !== null) {
      const removedTab = tabButtons[expensesDelTitle.index];
      if (removedTab && removedTab.id) {
        setDeletedTabIds((prev) => [...prev, removedTab.id]);
      }
      console.log("deletedTabIds", deletedTabIds);
      setTabButtons((prevTabs) => {
        const updatedTabs = prevTabs.filter((_, index) => index !== expensesDelTitle.index);

        // Determine the next tab to select
        let newActiveTab = null;
        if (updatedTabs.length > 0) {
          const newIndex = expensesDelTitle.index >= updatedTabs.length ? updatedTabs.length - 1 : expensesDelTitle.index;
          newActiveTab = updatedTabs[newIndex].key;
        }

        setActiveTab(newActiveTab);
        return updatedTabs;
      });

      setRowsByTab((prevRows) => {
        const updatedRows = { ...prevRows };
        const oldKey = tabButtons[expensesDelTitle.index]?.key;
        if (oldKey) {
          delete updatedRows[oldKey];
        }
        return updatedRows;
      });

      // Add the removed tab's id to the list
    }
  }, [expensesDelTitle]);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setExpneseTitle(null);
    setNewExpenseName("");
    setShowModal(false);
  };

  const handleSaveExpense = () => {
    if (newExpenseName.trim() === "") return;

    const newKey = newExpenseName.toLowerCase().replace(/\s+/g, "-");

    setTabButtons((prev) => {
      const updated = [...prev];

      if (expensesTitle && expensesTitle.index >= 0 && expensesTitle.index < updated.length) {
        updated[expensesTitle.index] = {
          id: updated[expensesTitle.index].id || 0,
          key: newKey,
          label: newExpenseName,
        };
      } else {
        updated.push({ id: 0, key: newKey, label: newExpenseName });
      }

      return updated;
    });

    setRowsByTab((prev) => {
      const updated = { ...prev };

      if (expensesTitle && expensesTitle.index >= 0 && expensesTitle.index < tabButtons.length) {
        const oldKey = tabButtons[expensesTitle.index].key;

        if (updated.hasOwnProperty(oldKey)) {
          // Move data from oldKey to newKey
          updated[newKey] = updated[oldKey];
          delete updated[oldKey];
        } else {
          // If oldKey doesn't exist, initialize newKey with default data
          updated[newKey] = [{ id: 0, status: "", amount: "" }];
        }
      } else {
        // If expensesTitle or index is invalid, just create newKey
        updated[newKey] = [{ id: 0, status: "", amount: "" }];
      }

      return updated;
    });

    setActiveTab(newKey);
    handleCloseModal();
  };

  // API

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const tabDetails = Object.entries(rowsByTab).map(([key, entries]) => {
        const fields = [];
        const tab = tabButtons.find((tab) => tab.key === key);
        const tabId = tab ? tab.id : 0; // fallback to 0 if not found

        entries.forEach((entry) => {
          fields.push({
            id: entry.id || 0,
            name: entry.status || "",
            value: entry.amount !== "" && !isNaN(entry.amount) ? Number(entry.amount) : 0,
          });
        });

        return { id: tabId, name: key, fields: fields };
      });

      if (!selectedLicensePlate?.value || !currentKm) {
        setErrorMsg({
          vehicle_id: !selectedLicensePlate?.value ? "License plate is required" : "",
          current_km: !currentKm ? "Current KM is required" : "",
        });
        setIsLoader(false);
        return;
      }

      console.log("change ", tabDetails);
      const preSanitizeData = {
        vehicle_id: selectedLicensePlate?.value ?? "",
        km: currentKm,
        tabs: tabDetails,
        last_km: lastKmRecord,
        removed_tabs: deletedTabIds,
        removed_fields: deletedFieldIds,
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      let response;
      if (id == null) {
        response = await submitAPI(sanitizedData);
      } else {
        response = await UpdateAPI(sanitizedData, id);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400 && response.data?.error) {
        const validationTemp = {};
        Object.entries(response.data.error).forEach(([key, value]) => {
          console.log(`${key}: ${value}`);
          if (Array.isArray(value)) {
            if (value.length > 0 && typeof value[0] === "string") {
              validationTemp[key] = value[0];
            } else if (value.length > 0 && typeof value[0] === "object") {
              const tabErr = value[0];
              validationTemp[key] = tabErr.name || "Please verify expense fields";
            } else {
              validationTemp[key] = "";
            }
          } else if (typeof value === "string") {
            validationTemp[key] = value;
          } else {
            validationTemp[key] = "";
          }
        });
        console.log("validationTemp...", validationTemp);
        setErrorMsg(validationTemp);
      } else if (response.data.success === true) {
        console.log("success:", response.data.message);
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setTimeout(() => {
          navigate("/expenses", { state: { snackbarMessage: response.data.message, snackbarStatus: true } });
        }, 1200);
      } else {
        console.log("else error:", response.data.message);
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }

      return response.data;
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
        console.log("catch error");
        console.log(err.response.data.message);
        setSnackbarMessage(err.response.data.message);
        setSnackbarStatus(err.response.data.success);
        handleSnackbarShow();
      }
    } finally {
      setIsLoader(false);
    }
  };

  const getExpenseDetails = async () => {
    try {
      const response = await getExpenseDetAPI(id);

      console.log("vehicle details", response);
      if (response.data?.success) {
        const vehicleData = response.data.history;
        setVehicleName(vehicleData.name);
        setVinValue(vehicleData.vin);
        setTimeout(() => {
          setLastKmRecord(vehicleData.last_km);
          setCurrentKm(vehicleData.current_km);
        }, 1000);

        setSelectedLicensePlate({
          value: vehicleData.vehicle_id,
          label: vehicleData.lic_no,
        });
        const rowsByTabFromAPI = (vehicleData.tabs ?? []).reduce((acc, tab) => {
          // Use tab name as key
          const key = tab.name.toLowerCase().replace(/\s+/g, "-");

          acc[key] = (tab.fields ?? []).map((field) => ({
            id: field.id ?? null, // Keep id if needed
            status: field.name || "", // Convert API field name -> frontend status
            amount: field.value || "", // Convert API field value -> frontend amount
          }));

          return acc;
        }, {});

        // Also create tabButtons from API
        const tabButtonsFromAPI = (vehicleData.tabs ?? []).map((tab) => ({
          id: tab.id,
          key: tab.name.toLowerCase().replace(/\s+/g, "-"),
          label: tab.name,
        }));
        console.log("rowsByTabFromAPI", rowsByTabFromAPI);
        console.log("tabButtonsFromAPI", tabButtonsFromAPI);
        // Example usage:
        setRowsByTab(rowsByTabFromAPI);
        setTabButtons(tabButtonsFromAPI);

        // Set first tab active
        if (tabButtonsFromAPI.length > 0) {
          setActiveTab(tabButtonsFromAPI[0].key);
        }
        console.error("Failed to fetch vehicle details:", response.data?.message);
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
  return (
    <>
      <div className="w-100 bg-half-white">
        <div
          className="d-flex align-items-center justify-content-between bg-white"
          style={{
            paddingLeft: "16px",
            paddingRight: "16px",
            borderTop: "1px solid #EBEBEB",
            borderBottom: "1px solid #EBEBEB",
          }}
        >
          <div className="d-flex gap-3 my-3">
            <MoveLeft className="cursor-pointer" onClick={() => navigate("/expenses")} />
            <p className="fw-semibold m-0">{id !== null && id !== undefined ? "Edit" : "Add"} Expense</p>
          </div>
          <div className="d-flex gap-3">
            <Button className="bg-white rounded-pill px-4 py-2 pagination-color btn-border-grey" onClick={() => navigate("/expenses")}>
              Cancel
            </Button>
            <div className="d-flex justify-content-center">
              <Button className={`d-flex justify-content-center dark-purple-btn ${isLoader ? "disabled-btn" : ""} rounded-pill py-2 px-4`} onClick={submitForm} style={{ minWidth: "100px" }}>
                {isLoader ? <Spinner animation="border" size="sm" /> : id !== null && id !== undefined ? "Update" : "Save"}
              </Button>
            </div>
          </div>
        </div>
        <div className="p-3">
          <div className="bg-white rounded-4 p-3 mt-4">
            <p className="fs-18 fw-600">Vehicle information</p>
            <div className="row">
              <div className="col-xl-4">
                <label htmlFor="vin" className="form-label fw-400 d-flex">
                  License plate<span className="error-text">*</span>
                </label>
                <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select license  plate" value={selectedLicensePlate} onSelect={handleSelectLicensePlate} /> <span className="error-text">{errorMsg.vehicle_id}</span>
              </div>
              <div className="col-xl-4">
                <label htmlFor="fill" className="form-label  fw-400">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control rounded-3 vehicle-form-input"
                  id="fill"
                  placeholder="vehicle name"
                  value={vehicleName}
                  readOnly
                  style={{
                    backgroundColor: "#F8F8F8",
                    border: "0.8px solid #E5E5E5",
                    pointerEvents: "none", // optional: prevents editing
                  }}
                />
              </div>
              <div className="col-xl-4">
                <label htmlFor="fill" className="form-label  fw-400">
                  Vehicle Identification Number (VIN)
                </label>
                <input
                  type="text"
                  className="form-control rounded-3 vehicle-form-input"
                  id="fill"
                  value={vinValue}
                  placeholder="Vin"
                  readOnly
                  style={{
                    backgroundColor: "#F8F8F8",
                    border: "0.8px solid #E5E5E5",
                    pointerEvents: "none", // optional: prevents editing
                  }}
                />
              </div>
              <div className="col-xl-4 mt-3">
                <label htmlFor="fill" className="form-label  fw-400 ">
                  Last KM
                </label>
                <input
                  type="text"
                  className="form-control rounded-3 vehicle-form-input"
                  id="fill"
                  placeholder="Last Km Record"
                  value={lastKmRecord}
                  readOnly
                  style={{
                    backgroundColor: "#F8F8F8",
                    border: "0.8px solid #E5E5E5",
                    pointerEvents: "none", // optional: prevents editing
                  }}
                />
              </div>
              <div className="col-xl-4 mt-3">
                <label htmlFor="fill" className="form-label  fw-400 d-flex">
                  Current KM<span className="error-text">*</span>
                </label>
                <input type="number" value={currentKm} className="form-control rounded-3 vehicle-form-input" id="fill" onChange={handleCurrentKmChange} placeholder="Enter here..." /> <span className="error-text">{errorMsg.km}</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-4 p-3 mt-4">
            <>
              {/* Tab Buttons */}
              <div className="d-flex align-items-center flex-wrap justify-content-between">
                {
                  <div className="d-flex flex-wrap gap-3 align-items-center">
                    {tabButtons.map((tab, index) => (
                      <div className="d-flex d-xl-flex flex-wrap gap-3">
                        <button
                          key={tab.key}
                          onClick={() => setActiveTab(tab.key)}
                          className={`px-3 py-2 rounded-pill ${activeTab === tab.key ? "border-0 text-dark-purple" : "pagination-border bg-white"}`}
                          style={{
                            backgroundColor: activeTab === tab.key ? "#EACDFF" : "#fff",
                          }}
                        >
                          {tab.label}

                          {activeTab === tab.key && (
                            <MoreVertical
                              size={16}
                              className="cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation(); // prevent setting active tab when clicking menu
                                toggleDropdown(tab.key);
                              }}
                            />
                          )}
                        </button>{" "}
                        {/* Dropdown */}
                        {openDropdown === tab.key && (
                          <div
                            className="tab-dropdown position-absolute bg-white border rounded shadow"
                            style={{
                              top: "67%", // directly below the button
                              right: "74%", // align right with the button
                              minWidth: "120px",
                              zIndex: 10,
                            }}
                          >
                            <div
                              className="px-3 py-2 cursor-pointer hover-bg-light"
                              onClick={() => {
                                console.log("Edit...", tab);
                                setExpneseTitle({
                                  name: tab.key,
                                  index: index,
                                });
                                setOpenDropdown(null);
                              }}
                            >
                              Edit
                            </div>
                            <div
                              className="px-3 py-2 cursor-pointer hover-bg-light"
                              onClick={() => {
                                console.log("Delete", tab.key);
                                setExpneseDelTitle({
                                  name: tab.key,
                                  index: index,
                                });
                                setOpenDropdown(null);
                              }}
                            >
                              Delete
                            </div>
                          </div>
                        )}{" "}
                      </div>
                    ))}
                  </div>
                }
                {/* Add Expenses Button */}
                <button className="d-flex align-items-center px-3 py-2 border-0 rounded-pill text-dark-purple mt-3" onClick={handleOpenModal}>
                  <Plus />
                  Add expenses
                </button>
                <Modal show={showModal} onHide={handleCloseModal} centered>
                  <Modal.Header closeButton>
                    <Modal.Title>{expensesTitle !== null ? "Edit expense" : "Add expense"}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <input type="text" className="form-control rounded-3" placeholder="Enter expense name" value={newExpenseName} onChange={(e) => setNewExpenseName(e.target.value)} />
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="light" onClick={handleCloseModal}>
                      Cancel
                    </Button>
                    <Button className="dark-purple-btn" onClick={handleSaveExpense}>
                      {expensesTitle !== null ? "Update" : "Save"}
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
              {/* Render content based on active tab */}
              <p className="fs-15 fw-600 mt-3 m-0">
                {tabButtons.find((tab) => tab.key === activeTab)?.label}
                &nbsp;
                {tabButtons.length > 0 ? ` Details` : ""}
              </p>

              {rowsByTab[activeTab]?.map((row, index) => (
                <div className="row mt-3" key={index}>
                  <div className="col-xl-4">
                    {index === 0 && (
                      <label htmlFor={`status-${index}`} className="form-label fw-400">
                        Expense Name
                      </label>
                    )}
                    <input type="text" className="form-control rounded-3 vehicle-form-input" id={`name-${index}`} placeholder="Enter here..." value={row.status} onChange={(e) => handleExpenseNameChange(activeTab, index, e.target.value)} />
                  </div>

                  <div className="col-xl-4">
                    {index === 0 && (
                      <label htmlFor={`amount-${index}`} className="form-label fw-400">
                        Amount
                      </label>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input type="number" className="form-control rounded-3 vehicle-form-input" id={`amount-${index}`} placeholder="Enter here..." value={row.amount} onChange={(e) => handleAmountChange(activeTab, index, e.target.value)} />
                      {index === rowsByTab[activeTab].length - 1 ? (
                        <div className="d-flex ">
                          {rowsByTab[activeTab].length > 1 && <img className="cursor-pointer" src={remove} alt="remove" onClick={() => handleRemove(activeTab, index)} style={{ width: "35px", height: "35px" }} />} <img className="cursor-pointer" src={add} alt="add" onClick={() => handleAdd(activeTab)} style={{ width: "35px", height: "35px" }} />
                        </div>
                      ) : (
                        <img className="cursor-pointer" src={remove} alt="remove" onClick={() => handleRemove(activeTab, index)} style={{ width: "35px", height: "35px" }} />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999, position: "fixed" }}>
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
